export const Approved = {
    name: 'Approved',
    value: 'APPROVED',
    sequence: 1,
};
export const Draft = {
    name: 'Draft',
    value: 'DRAFT',
    sequence: 2,
};
const Basic = [Approved, Draft];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicProps,
    Approved,
    Draft,
};
